export default "__VITE_ASSET__BreYgYLA__"